<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      ref="leaveModal"
      id="leaveModal"
      size="md"
      title="Discard Changes?"
      ok-variant="danger"
      ok-title="Discard"
      hide-header-close
      cancel-title="Cancel"
      no-close-on-backdrop
    >
      <p class="mt-75 mb-25 font-weight-bolder text-danger">
        You Have Unsaved Changes !
      </p>
      <p class="mb-75 font-weight-bold">
        If you go back now, you'll lose all the changes you've made.
      </p>
    </b-modal>

    <b-card>
      <b-button
        v-if="$route.fullPath == '/Reception/Add'"
        @click="changeCurrentStep('back')"
        variant="danger"
        class="mb-1 mx-1"
      >
        <b-icon-arrow-left class="mr-1"></b-icon-arrow-left>
        {{ $t('common.previous-step') }}
      </b-button>
      <b-button
        v-if="$route.fullPath == '/Reception/Add'"
        style="float: right"
        @click="
          stepCompletion[currentStep] ? changeCurrentStep('forward') : null
        "
        variant="warning "
        :class="currentStep === 2 ? 'd-none' : 'mx-1'"
        :disabled="!stepCompletion[currentStep]"
      >
        {{ $t('common.next-step') }}
        <b-icon-arrow-right class="ml-1"></b-icon-arrow-right>
      </b-button>
      <div class="m-2">
        <!-- Add Patient Name -->
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t('reception.add-patient') }}</h2>
            <br />
          </b-col>
          <b-col v-if="$route.fullPath == '/Reception/Add'">
            <div style="line-height: 1.1; margin-bottom: 4rem">
              <step-progress
                :steps="mySteps"
                :current-step="currentStep"
                icon-class="fa fa-check"
                active-color="#3e964d"
                passive-color="#e3827b"
                :active-thickness="4"
                :passive-thickness="4"
                :line-thickness="10"
              >
              </step-progress>
            </div>
          </b-col>
        </b-row>
        <div v-if="currentStep == 0">
          <b-row>
            <b-col cols="12" md="12">
              <br />
            </b-col>
            <b-col md="6" cols="12">
              <b-form-group
                :label="$t('reception.patient-name')"
                label-for="Name"
              >
                <b-form-input
                  id="Name"
                  v-model="addForm.name"
                  :placeholder="$t('reception.patient-name')"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="1">
              <br />
            </b-col>
            <!-- add Patient's Mother name -->
            <!-- we can delete the spaces created by the errors handler using the br below -->
            <!-- <br v-if="!errorForm.first_name && !errorForm.second_name && !errorForm.third_name && !errorForm.forth_name " />  -->
            <b-col md="4" cols="12" v-if="$route.fullPath == '/Reception/Add'">
              <b-form-group
                :label="$t('reception.patient-mother-name')"
                label-for="Name"
              >
                <b-form-input
                  id="Name"
                  v-model="addForm.mother_name"
                  :placeholder="$t('reception.patient-mother-name')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <br />
              <b-form-group :label="$t('reception.gender')" label-for="Gender">
                <v-select
                  v-model="addForm.gender"
                  :options="genderOption"
                  :placeholder="$t('reception.gender')"
                />
                <p v-if="errorForm.gender" class="ml-25 error">
                  This field is required.
                </p>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <br />
              <div>
                <b-form-group
                  :label="$t('reception.birth-date')"
                  label-for="birthday"
                >
                  <datepicker
                    v-model="birthday_input"
                    :calendar-button="true"
                    :clear-button="true"
                    format="yyyy-MM-dd"
                    :bootstrap-styling="true"
                    style="height: 5rem"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  ></datepicker>
                </b-form-group>
                <p v-if="errorForm.birthday" class="ml-25 error error_1">
                  This field is required.
                </p>
              </div>
              <!-- <br v-if="errorForm.birthday" /> -->
            </b-col>
            <b-col md="4">
              <br />
              <b-form-group
                :label="$t('reception.phone')"
                label-for="phoneNumber"
              >
                <VuePhoneNumberInput
                  v-model="addForm.phone"
                  @update="
                    (obj) => {
                      showPhoneObj(obj, 'countryCallingCode');
                    }
                  "
                  default-country-code="IQ"
                  :error="
                    addForm.phone ? isNotValid || addForm.phone[0] != 0 : false
                  "
                />
                <p v-if="errorForm.phone" class="ml-25 error">
                  This field is required.
                </p>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <h4>{{ $t('reception.address') }}</h4>
              <AutoComplete
                :label="$t('reception.governorate')"
                :placeholder="$t('reception.governorate')"
                v-model="addForm.governorate_id"
                :serializer="(val) => val.id"
                param-query="search"
                endpoint="governorate"
                text-title="name"
              />
            </b-col>
            <b-col md="2">
              <br />
              <h4></h4>
              <AutoComplete
                :label="$t('reception.city-name')"
                :placeholder="$t('reception.city-name')"
                v-model="addForm.city_name"
                :serializer="(val) => val.name"
                param-query="search"
                endpoint="city"
                text-title="name"
              />
            </b-col>
            <b-col md="2" v-if="$route.fullPath == '/Reception/Add'">
              <br />
              <h4></h4>
              <b-form-group
                :label="$t('reception.judiciary-name')"
                label-for="Street"
              >
                <b-form-input
                  v-model="addForm.judiciary_name"
                  :placeholder="$t('reception.judiciary-name')"
                />
              </b-form-group>
            </b-col>

            <b-col md="2" v-if="$route.fullPath == '/Reception/Add'">
              <br />
              <h4></h4>
              <b-form-group
                :label="$t('reception.district-name')"
                label-for="District"
              >
                <b-form-input
                  v-model="addForm.district_name"
                  :placeholder="$t('reception.district-name')"
                />
              </b-form-group>
            </b-col>
            <b-col md="2" v-if="$route.fullPath == '/Reception/Add'">
              <br />
              <h4></h4>
              <b-form-group
                :label="$t('reception.street-name')"
                label-for="Building"
              >
                <b-form-input
                  v-model="addForm.street_name"
                  :placeholder="$t('reception.street-name')"
                />
              </b-form-group>
            </b-col>
            <b-col md="2" v-if="$route.fullPath == '/Reception/Add'">
              <br />
              <h4></h4>
              <b-form-group
                :label="$t('reception.building-number')"
                label-for="Building"
              >
                <b-form-input
                  v-model="addForm.building_number"
                  :placeholder="$t('reception.building-number')"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Add Button -->
          <b-row>
            <b-col cols="12" md="12">
              <br />
            </b-col>

            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <b-button
                style="margin: auto"
                variant="primary"
                @click="addNewItem()"
              >
                {{ $t('common.submit') }}
                <b-icon-person-check class="ml-1"></b-icon-person-check>
              </b-button>
            </b-col>
          </b-row>
        </div>
        <!-- <div v-if="currentStep == 1">
          <b-row>
            <b-col cols="12" md="12">
              <br />
              <h4>Medical Info</h4>
            </b-col>
            <b-col md="4" cols="12">
              <b-form-group
                label="Does the Patient have diabetes?"
                label-for="Name"
              >
                <b-form-checkbox
                  class="checkbox-visit"
                  v-for="(option, index) in [
                    { text: 'Yes', value: true },
                    { text: 'No', value: false },
                  ]"
                  v-model="addForm.has_diabetes"
                  :key="index"
                  :value="option.value"
                  name="flavour-3a"
                >
                  {{ option.text }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="4" cols="12">
              <b-form-group
                label="Does the Patient have high blood pressure?"
                label-for="Name"
              >
                <b-form-checkbox
                  class="checkbox-visit"
                  v-for="(option, index) in [
                    { text: 'Yes', value: true },
                    { text: 'No', value: false },
                  ]"
                  v-model="addForm.has_high_blood_pressure"
                  :key="index"
                  :value="option.value"
                  name="flavour-3a"
                >
                  {{ option.text }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="4" cols="12">
              <b-form-group
                label="Does the Patient have heart disease?"
                label-for="Name"
              >
                <b-form-checkbox
                  class="checkbox-visit"
                  v-for="(option, index) in [
                    { text: 'Yes', value: true },
                    { text: 'No', value: false },
                  ]"
                  v-model="addForm.has_heart_disease"
                  :key="index"
                  :value="option.value"
                  name="flavour-3a"
                >
                  {{ option.text }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="12">
              <br />
              <br />
              <h4>Weight & Height</h4>
            </b-col>
            <b-col md="3" cols="12">
              <b-form-group label="Patient's weight" label-for="weight">
                <b-form-input
                  v-model="addForm.weight"
                  placeholder="Enter Patient's weight"
                  type="number"
                />
              </b-form-group>
            </b-col>
            <b-col md="1" cols="12"> </b-col>
            <b-col md="3" cols="12">
              <b-form-group label="Patient's height" label-for="height">
                <b-form-input
                  v-model="addForm.height"
                  placeholder="Enter Patient's height"
                  type="number"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="12">
              <br />
            </b-col>
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <b-button
                style="margin: auto"
                variant="primary"
                @click="addNewItem()"
              >
                Update Medical Info
                <b-icon-file-medical class="ml-1"></b-icon-file-medical>
              </b-button>
            </b-col>
          </b-row>
        </div> -->
        <div v-if="currentStep == 1">
          <b-row v-if="$route.fullPath == '/Reception/Add'">
            <b-col cols="12" md="12">
              <br />
              <br />
            </b-col>
            <b-col md="6" cols="12">
              <b-form-group
                :label="$t('reception.companion-name')"
                label-for="Name"
              >
                <b-form-input
                  id="Name"
                  v-model="cardForm.full_companion_name"
                  :placeholder="$t('reception.companion-name')"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                :label="$t('reception.companion-phone')"
                label-for="phoneNumber"
              >
                <VuePhoneNumberInput
                  v-model="cardForm.companion_phone"
                  @update="
                    (obj) => {
                      showPhoneObj(obj, 'countryCallingCode');
                    }
                  "
                  default-country-code="IQ"
                  :error="
                    addForm.companion_phone
                      ? isNotValid || addForm.companion_phone[0] != 0
                      : false
                  "
                />
                <p v-if="errorForm.companion_phone" class="ml-25 error">
                  This field is required.
                </p>
              </b-form-group>
            </b-col>
            <b-col md="6" cols="12">
              <b-form-group
                :label="$t('reception.next-kin-name')"
                label-for="Name"
              >
                <b-form-input
                  id="Name"
                  v-model="cardForm.next_of_kin_name"
                  :placeholder="$t('reception.next-kin-name')"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                :label="$t('reception.next-kin-phone')"
                label-for="phoneNumber"
              >
                <VuePhoneNumberInput
                  v-model="cardForm.next_of_kin_phone_number"
                  @update="
                    (obj) => {
                      showPhoneObj(obj, 'countryCallingCode');
                    }
                  "
                  default-country-code="IQ"
                  :error="
                    addForm.next_of_kin_phone_number
                      ? isNotValid || addForm.next_of_kin_phone_number[0] != 0
                      : false
                  "
                />
                <p v-if="errorForm.phone" class="ml-25 error">
                  This field is required.
                </p>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group :label="$t('reception.card-type')" label-for="Type">
                <v-select
                  v-if="$route.fullPath == '/Reception/Add'"
                  v-model="cardForm.type"
                  :options="['IN', 'OUT', 'EMERGENCY', 'CLINIC', 'LAB']"
                  :placeholder="$t('reception.card-type')"
                />

                <p v-if="errorForm.gender" class="ml-25 error">
                  This field is required.
                </p>
              </b-form-group>
            </b-col>
            <b-col md="4" cols="12">
              <b-form-group
                :label="$t('reception.patient-case')"
                label-for="Case"
                v-if="$route.fullPath == '/Reception/Add'"
              >
                <b-form-input
                  id="Case"
                  v-model="cardForm.patient_case"
                  :placeholder="$t('reception.patient-case')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <!-- <b-row v-if="$route.fullPath == '/Reception/Add'">
            <b-col md="10" cols="12">
              <b-form-group
                :label="$t('reception.patient-case-detalis')"
                label-for="Case_Details"
              >
                <b-form-textarea
                  id="Case_Details"
                  v-model="cardForm.patient_case_details"
                  :placeholder="$t('reception.patient-case-detalis')"
                />
              </b-form-group>
            </b-col>
          </b-row> -->
          <!-- Add Button -->
          <b-row>
            <b-col cols="12" md="12">
              <br />
            </b-col>
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <b-button
                style="margin: auto"
                variant="primary"
                @click="addNewItem()"
              >
                {{ $t('reception.card-creation') }}
                <b-icon-file-person class="ml-1"></b-icon-file-person>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
  <!-- Table Container Card -->
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BModal,
  BAlert,
  VBModal,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormDatepicker,
  BIconCalendar,
  BIcon,
  BIconArrowLeft,
  BIconArrowRight,
  BIconFilePerson,
  BIconFileMedical,
  BIconPersonCheck,
  BFormCheckbox,
  BFormTextarea,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import Datepicker from 'vuejs-datepicker';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';
const AutoComplete = () => import('@/components/common/AutoComplete.vue');

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BAlert,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormDatepicker,
    Datepicker,
    VuePhoneNumberInput,
    'step-progress': StepProgress,
    BFormCheckbox,
    BIcon,
    BIconArrowLeft,
    BIconArrowRight,
    BIconFilePerson,
    BIconPersonCheck,
    BIconFileMedical,
    BFormTextarea,
    AutoComplete,
  },

  data() {
    return {
      mySteps: [
        this.$t('reception.personal-info'),
        this.$t('reception.card-creation'),
      ],
      stepCompletion: [false, false, false], // One boolean for each step

      currentStep: 0,
      cardForm: {
        full_companion_name: '',
        next_of_kin_name: '',
        next_of_kin_phone_number: '',
        companion_phone: '',
        patient_case: '',
        patient_case_details: '',
        type: '',
        patient_id: '',
      },
      addForm: {
        first_name: '',
        second_name: '',
        third_name: '',
        forth_name: '',
        nickname: '',
        first_mother_name: '',
        second_mother_name: '',
        third_mother_name: '',
        forth_mother_name: '',
        national_id: '',
        card_type: '',
        phone: '',
        second_phone: '',
        adderss: '',
        birthday: '',
        governorate_id: '',
        gender: '',
        patient_referred_from: '',
      },
      errorForm: {
        first_name: '',
        second_name: '',
        third_name: '',
        forth_name: '',
        nickname: '',
        first_mother_name: '',
        second_mother_name: '',
        third_mother_name: '',
        forth_mother_name: '',
        national_id: '',
        card_type: '',
        phone: '',
        second_phone: '',
        age: '',
        adderss: '',
        birthday: '',
        governorate_id: '',
        gender: '',
      },
      patient_referred_from_details: '',
      genderOption: ['Male', 'Female'],
      cities: [],
      city: '',
      take: 10,
      loading: true,
      selected: '',
      dateValue: '',
      birthday_input: '',
      formattedDate: '',
      selectedDate: '',
      option: [],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
      params: {
        form: {},
        path: '',
      },
      countryCallingCodeFirst: '',
      countryCallingCodeSecond: '',
      answer: null,
      completedSubmit: false,
      nameValue: '',
      isNotValid: false,
      submitting: false,
    };
  },
  mounted() {
    this.getCities();
    console.log('rpiy', this.$route.fullPath == '/Search-Patient/Add');
  },
  methods: {
    changeCurrentStep(order) {
      order == 'back'
        ? (this.currentStep -= 1)
        : this.currentStep != 2
        ? (this.currentStep += 1)
        : this.currentStep;
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      return [year, month, day].join('-');
    },

    async getCities() {
      await this.getList(`/city?take=1000`);
      for (let item in this.all_data.data) {
        this.cities.push(this.all_data.data[item]);
      }
    },
    onContext(ctx) {
      // The date formatted in the locale, or the `label-no-date-selected` string
      this.formattedDate = ctx.selectedFormatted;
      // The following will be an empty string until a valid date is entered
      this.selectedDate = ctx.selectedYMD;
    },
    addNewItem() {
      this.addForm.birth_date = this.formatDate(this.birthday_input);
      if (this.addForm.patient_referred_from) {
        this.addForm.patient_referred_from =
          this.addForm.patient_referred_from +
          ', ' +
          this.patient_referred_from_details;
      }
      if (this.addForm.birth_date == 'NaN-NaN-NaN') {
        this.addForm.birth_date = '';
      }
      if (this.city) {
        this.addForm.governorate_id = (
          this.cities.indexOf(this.city) + 1
        ).toString();
      }
      // empty the error form for next check
      // and delete the extra keys that are not required from the form we're sending to server
      for (let item in this.errorForm) {
        this.errorForm[item] = '';
        if (this.addForm[item] == '') delete this.addForm[item];
      }
      if (this.addForm.phone) {
        this.addForm.phone =
          '+' +
          this.countryCallingCodeFirst +
          (this.addForm.phone[0] == '0'
            ? this.addForm.phone.slice(1)
            : this.addForm.phone);
      }
      if (this.addForm.second_phone) {
        this.addForm.second_phone =
          '+' +
          this.countryCallingCodeSecond +
          (this.addForm.second_phone[0] == '0'
            ? this.addForm.second_phone.slice(1)
            : this.addForm.second_phone);
      }
      if (this.$route.fullPath == '/patients-tests/Add') {
        this.cardForm.type = 'LAB';
      }

      if (this.$route.fullPath != '/patients-tests/Add') {
        this.currentStep = this.currentStep + 1;
      }

      if (
        this.currentStep === 2 ||
        this.$route.fullPath == '/patients-tests/Add'
      ) {
        (this.params.form = this.addForm),
          (this.params.path = '/patient'),
          this.$store
            .dispatch('create', this.params)
            .then((response) => {
              this.cardForm.patient_id = response.data.data.id;
              this.params.form = this.cardForm;
              this.params.path = '/patientCard';
              this.$store
                .dispatch('create', this.params)
                .then((response) => {})
                .catch((error) => {
                  console.log(error);
                });
              this.$set(this.stepCompletion, this.currentStep, true);

              this.completedSubmit = true;
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'User Created',
                  icon: 'success',
                  variant: 'info',
                  text:
                    'Patient ' +
                    this.addForm.first_name +
                    ' Has Been Created Successfully',
                },
              });
              // if (this.requestPermission.includes('store-patient-card')) {
              //   this.$router.push({
              //     name: 'Reception-patient-create-card',
              //     params: { id: response.data.data.id },
              //   });
              // } else {
              //   this.$router.push({ name: 'Reception-Departments' });
              // }
            })
            .catch((error) => {
              if (this.addForm.phone) {
                this.addForm.phone =
                  this.addForm.phone[0] == '0'
                    ? this.addForm.phone
                    : '0' + this.addForm.phone;
              }
              if (this.addForm.second_phone) {
                this.addForm.second_phone =
                  this.addForm.second_phone[0] == '0'
                    ? this.addForm.second_phone
                    : '0' + this.addForm.second_phone;
              }
              if (error.response.status === 400) {
                Object.keys(error.response.data).forEach((item) => {
                  this.errorForm[item] = error.response.data[item][0];
                });
              }
            })
            .finally(() => {
              if (this.$route.fullPath == '/Search-Patient/Add') {
                this.$router.push({ name: 'Reception-Search' });
              } else if (this.$route.fullPath == '/patients-tests/Add') {
                this.$router.push({ name: 'patients-lab' });
              } else {
                this.$router.push({ name: 'Reception-Departments' });
              }

              // if (this.currentStep !== 2) {
              //   this.currentStep = this.currentStep + 1;
              // } else {
              // }
            });
      }
    },
    setName(name, value, blur) {
      if (blur != 'blur') {
        this.nameValue = value;
      }
      if (blur == 'blur') {
        this.addForm[name] = this.nameValue;
      }
    },
    showLeaveModal() {
      this.$refs.leaveModal.show();
    },
    handleLeaveModalOk() {
      this.answer = 'OK';
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.completedSubmit) {
      let count = 0;
      for (let item in this.addForm) {
        if (this.addForm[item]) {
          count++;
        }
      }
      if (count) {
        this.showLeaveModal();
        this.$nextTick(() => {
          this.$refs.leaveModal.$once('hide', (bvEvt) => {
            if (bvEvt.trigger === 'ok') {
              this.$refs.leaveModal.$once('hidden', () => {
                next();
              });
            } else {
              next(false);
            }
          });
        });
      } else {
        next();
      }
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
.error {
  color: rgb(255, 0, 0) !important;
}

.error_1 {
  position: absolute;
  top: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.checkbox-visit {
  margin-left: 1.5rem;
  margin-top: 1rem;
}
</style>
